import { useEffect as e, useState as t } from "react";
//#region src/hooks/useHover.ts
var n = (n) => {
	let [r, i] = t(!1), a = () => i(!0), o = () => i(!1);
	return e(() => (n.current && n.current.addEventListener("mouseenter", a), () => {
		n.current && n.current.removeEventListener("mouseenter", a);
	}), [n.current]), e(() => (n.current && n.current.addEventListener("mouseleave", o), () => {
		n.current && n.current.removeEventListener("mouseleave", o);
	}), [n.current]), r;
};
//#endregion
export { n as default };

//# sourceMappingURL=useHover.js.map